module.exports = __webpack_public_path__ + "static/media/430283477_373528012115932_3516528325512254109_n.ae8b136a.jpg";